/**
 * RotatedCaption — vertical 90°-rotated gold caption used as a sidebar
 * marker on hero and section edges. Mirrors the after-mockup pattern
 * "CHAPTER 01 / 04 PRODUCTS".
 *
 * @example
 *   <RotatedCaption>CHAPTER 01 · 04 PRODUCTS</RotatedCaption>
 *   <RotatedCaption side="right" tone="cream">2026 · ISSUE 01</RotatedCaption>
 */
import React from "react";

const TONE = {
  gold:     "text-[color:var(--gold-base)]",
  cream:    "text-[color:var(--cream)]",
  charcoal: "text-[color:var(--charcoal)]",
};

export default function RotatedCaption({
  children,
  side = "left",  // left | right — which side of the parent it sits on
  tone = "gold",
  className = "",
  ...rest
}) {
  const rotation = side === "right" ? "rotate-90" : "-rotate-90";
  return (
    <span
      className={`ed-eyebrow inline-block whitespace-nowrap transform ${rotation} origin-center ${TONE[tone] || TONE.gold} ${className}`}
      {...rest}
    >
      {children}
    </span>
  );
}
